import React from 'react'
import { ISearchFilterOption } from '../../../../../context/search/types'
import useSearch from '../../../../../context/search/useSearch'

interface ISwatchFilter {
  option: ISearchFilterOption
}

interface ISwatchFilterWrap {
  option: ISearchFilterOption
  children: React.ReactNode
}

const SwatchFilterWrap: React.FC<ISwatchFilterWrap> = ({ children, option }) => <>
  {children}
  <span className="filter__swatches">
    {
      <span className='filter__swatches-inner'>
        {
          isNaN(option.records)
            ? option.label
            : (
              <>
                {option.label}<span className='filter__count filter__count--swatches'>({option.records})</span>
              </>
            )
        }
      </span>
    }
  </span>
</>

const SwatchFilter: React.FC<ISwatchFilter> = ({ option }) => {
  const { filterSwatches } = useSearch()
  const { identifier, color } = option
  let swatch
  if (window['blubolt'].SearchService === 'boostcommerce') {
    // Boost supplies a shopify metaobject reference, we need to
    // split this reference and just get the ID which is the last
    // part of the identifier
    const swatchId = parseInt(identifier.split('/')[identifier.split('/').length - 1])
    // We then match the ID
    swatch = filterSwatches.find(({ id }) => id === swatchId)
    // Because the option label is the metaobject reference and
    // therefore useless we set it to the swatch title
    option.label = swatch.title
  } else if (window['blubolt'].SearchService === 'voyado' && color) {
    swatch = {
      color: color,
      title: identifier
    }
  } else if (window['blubolt'].SearchService === 'voyado' && !color) {
    // Voyado without explicit color - use identifier as the color value
    // This handles cases like "Multi coloured" where we need to detect special colors
    swatch = {
      color: identifier,
      title: identifier
    }
  } else {
    swatch = filterSwatches.find(({ title }) => title.toLowerCase() === identifier.toLowerCase())
  }

  // Helper function to get swatch style
  const getSwatchStyle = () => {
    if (!swatch?.color) {
      return { backgroundColor: 'none' };
    }


    const colorLower = swatch.color.toLowerCase().trim();

    // Check for multicolour/multi-color variants
    if (colorLower === 'multicolour' || colorLower === 'multi-colour' || colorLower === 'multi-color' || colorLower === 'multi' || colorLower === 'multicolor' || colorLower === 'multicoloured' || colorLower === 'multi coloured') {
      return {
        background: 'linear-gradient(to bottom right, #b827fc, #2c90fc 25%, #b8fd33 50%, #fec837 75%, #fd1892)'
      };
    }

    return { backgroundColor: swatch.color };
  };

  if (swatch?.pattern) {
    return (
      <SwatchFilterWrap option={option}>
        <span className='filter__swatch filter__swatch--img'><img width="80" height="80" alt={swatch.title} src={swatch.pattern} /></span>
      </SwatchFilterWrap>
    )
  } else {
    return (
      <SwatchFilterWrap option={option}>
        <span className='filter__swatch filter__swatch--bg' style={getSwatchStyle()}></span>
      </SwatchFilterWrap>
    )
  }
}

export default SwatchFilter